import { render, staticRenderFns } from "./alimentAction.vue?vue&type=template&id=054968ba"
import script from "./alimentAction.vue?vue&type=script&lang=js"
export * from "./alimentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports